<div class="grid-container grid-3 grid-align-items-center" [formGroup]="formGroup">
    <ui-form-field class="grid-span-2" [label]="'TAILORED_WIDGET.CUSTOM_IMAGE_BASE64.IMAGE_FILE' | translate">
        <input
            advizeoInput
            type="text"
            [required]="true"
            [readonly]="true"
            [value]="formGroup.value.image64 | applyPureFunction: getDisplayedImageBase64Name"
            (click)="triggerInput('image64')"
        />
        <input
            class="hidden-input"
            advizeoInput
            id="image64"
            type="file"
            [accept]="acceptedExtensionsText"
            (change)="imageChangeEvent($event)"
        />
    </ui-form-field>

    <ui-icon-button iconName="select-file" size="small" (click)="triggerInput('image64')" />

    <ui-form-field [label]="'TAILORED_WIDGET.CUSTOM_IMAGE_BASE64.DISPLAY_TYPE' | translate">
        <ui-select formControlName="displayType" valueField="code" labelField="label" [required]="true" [options]="options" />
    </ui-form-field>

    <ui-form-field [label]="'TAILORED_WIDGET.CUSTOM_IMAGE_BASE64.BACKGROUND_COLOR' | translate">
        <div class="flex-row">
            <input advizeoInput id="backgroundColor" formControlName="backgroundColor" type="color" />
            @if (formGroup.controls.backgroundColor.value) {
                <ui-icon-button iconName="remove" size="small" (click)="clearBgColor()" />
            } @else {
                <div class="no-color" (click)="triggerInput('backgroundColor')">
                    <ui-icon name="none" size="small" />
                </div>
            }
        </div>
    </ui-form-field>
</div>
